import styled from 'styled-components';
import getThemeTypography, { Typographies } from '../../utils/getThemeTypography';
export var HeaderFourTypography = styled.h4(getThemeTypography(Typographies.H4_HEADING));
